import script from "./Configurator.vue?vue&type=script&setup=true&lang=js"
export * from "./Configurator.vue?vue&type=script&setup=true&lang=js"

import "./Configurator.vue?vue&type=style&index=0&id=024e3716&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-024e3716"]])

export default __exports__